<template>
  <div v-loading="loading" class="page finance-order">
    <div class="block filters">
      <div class="statistic">
        共 {{ pagination.totalCount }} 条记录，金额合计：{{ totalAmount.amount.toFixed(2) }}, 付款合计：{{ totalAmount.amountPay.toFixed(2) }}, 挂账合计： {{ totalAmount.amountCreditPay.toFixed(2) }}, 现金合计：{{ (totalAmount.amountPay - totalAmount.amountCreditPay).toFixed(2) }}
      </div>
      <div class="query-form">
        <div class="field">
          <label>单号</label>
          <div>
            <el-input size="small" v-model="queryModel.orderSn" placeholder="订单编号" clearable></el-input>
          </div>
        </div>
        <div class="field">
          <label>买家</label>
          <div>
            <el-input size="small" v-model="queryModel.buyerName" placeholder="买家商户名称" clearable></el-input>
          </div>
        </div>
        <div class="field">
          <label>品牌</label>
          <div>
            <el-select size="small" v-model="queryModel.brandCode" placeholder="配件品牌" clearable>
              <el-option v-for="b in orderBrands" :label="b.name" :value="b.code" :key="b.code" />
            </el-select>
          </div>
        </div>
        <div class="field">
          <label>配件</label>
          <div>
            <el-input size="small" v-model="queryModel.partCode" placeholder="配件编号/名称" clearable></el-input>
          </div>
        </div>
        <div class="field">
          <label>支付方式</label>
          <div>
            <el-select size="small" v-model="queryModel.payType" placeholder="支付方式" clearable>
              <el-option v-for="tp in payTypes" :key="tp.id" :label="tp.name" :value="tp.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="field time">
          <label>下单时间</label>
          <div>
            <el-date-picker
              size="small"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              v-model="timeSpan"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="付款时间-开始"
              clearable
              @change="(val) => { queryModel.startTime = (val || [])[0]; queryModel.endTime = (val || [])[1]; }"
            />
          </div>
        </div>
        <div class="field">
          <label>卖家</label>
          <div>
            <el-select size="small" v-model="queryModel.subSellerId" placeholder="卖家" clearable>
              <el-option v-for="tp in subSellers" :key="tp.id" :label="tp.name" :value="tp.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="field">
          <el-button size="small" type="primary" @click="loadData(1)">搜索</el-button>
          <el-button size="small" type="default" @click="reset">重置</el-button>
        </div>
      </div>
      <div class="states-bar">
        <div v-for="state in states" :key="state.id" @click="stateChange(state.id)" class="state" :class="{ current: queryModel.state === state.id }">
          {{ state.name }}({{ state.count }})
        </div>
      </div>
    </div>
    <div v-if="list && list.length" class="block list">
      <order-item v-for="item in list" :key="item.id" :order="item"></order-item>
    </div>
    <div v-else class="block list">
      <div class="no-data">暂无数据</div>
    </div>
    <div v-if="pagination.totalCount > pagination.pageSize" class="block pager">
      <el-pagination
        background
        @current-change="(pageIndex) => loadData(pageIndex)"
        @size-change="(pageSize) => loadData(1, pageSize)"
        :page-sizes="[20, 30, 50, 100]"
        :current-page.sync="pagination.pageIndex"
        :page-size="pagination.pageSize"
        layout="sizes, prev, pager, next, jumper"
        :total="pagination.totalCount"
      >
      </el-pagination>
    </div>
    <div v-else class="no-pager"></div>
  </div>
</template>
<script>
import { ListOrder } from './services'
import OrderItem from './OrderItem.vue'
import moment from 'moment'
export default {
  name: 'FinanceOrder',
  components: { OrderItem },
  data () {
    const lastYear = moment().subtract(1, 'year').format('YYYY-MM-DD')
    const today = moment().format('YYYY-MM-DD')
    return {
      loading: false,
      queryModel: {
        brandCode: '',
        partCode: '',
        buyerName: '',
        orderSn: '',
        payType: undefined,
        state: undefined,
        startTime: lastYear,
        endTime: today,
        subSellerId: undefined
      },
      timeSpan: [lastYear, today],
      totalAmount: { amount: 0, amountPay: 0, amountCreditPay: 0 },
      states: [],
      list: [],
      pagination: {
        pageIndex: 1,
        pageSize: 30,
        totalCount: 0
      }
    }
  },
  computed: {
    payTypes () {
      return this.$store.state.payTypes.map((item, idx) => {
        if (item === '') {
          return null
        }
        return {
          id: idx,
          name: item
        }
      }).filter(t => t !== null)
    },
    orderStateEnums () {
      return this.$store.state.orderState
    },
    orderBrands () {
      return this.$store.state.orderBrands || []
    },
    subSellers () {
      return this.$store.state.subSellers || []
    }
  },
  beforeMount () {
    this.loadData()
    if (!this.orderBrands.length) {
      this.$store.dispatch('loadOrderBrands')
    }
  },
  methods: {
    reset () {
      Object.assign(this.queryModel, {
        brandCode: '',
        partCode: '',
        buyerName: '',
        orderSn: '',
        payType: undefined,
        startTime: undefined,
        endTime: undefined,
        subSellerId: undefined
      })
    },
    stateChange (destState) {
      this.queryModel.state = destState
      this.loadData(1)
    },
    loadData (pIndex, pSize) {
      const { pageIndex, pageSize } = this.pagination
      const { brandCode, partCode, buyerName, orderSn, payType, state, startTime, endTime, subSellerId } = this.queryModel
      const queryModel = {
        pageIndex: pIndex || pageIndex || 1,
        pageSize: pSize || pageSize || 30,
        brandCode: brandCode || undefined,
        partCode: partCode || undefined,
        buyerName: buyerName || undefined,
        orderSn: orderSn || undefined,
        payType: payType || 0,
        state: state || 0,
        subSellerId: +subSellerId || undefined,
        startTime: startTime || undefined,
        endTime: endTime ? endTime + ' 23:59:59' : undefined
      }
      this.loading = true
      ListOrder(queryModel).then((resp) => {
        this.pagination = resp.pagination
        this.totalAmount = resp.totalAmount
        this.states = this.orderStateEnums.map(t => {
          if (t.id === undefined) {
            return { ...t, count: resp.stateCounts.reduce((p, c) => p + c.count, 0) }
          } else {
            const countInfo = resp.stateCounts.find(s => s.state === t.id)
            return { ...t, count: (countInfo && countInfo.count) || 0 }
          }
        })
        this.list = resp.orders
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
